import { render, staticRenderFns } from "./FoodSafety.vue?vue&type=template&id=a8a55cf6&scoped=true&"
import script from "./FoodSafety.vue?vue&type=script&lang=ts&"
export * from "./FoodSafety.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a8a55cf6",
  null
  
)

export default component.exports